<div class="portal-form-wrapper">
  <div class="portal-form-header">
    <h2 class="portal-form-title">
      <mat-icon class="title-icon">edit</mat-icon>
      Редагувати портал
    </h2>
    <p class="portal-form-subtitle">Змініть дані порталу</p>
  </div>

  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="portal-form">
    <div class="form-section">
      <h3 class="section-title">Основна інформація</h3>

      <div class="form-row form-row--full">
        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Назва порталу</mat-label>
          <input matInput formControlName="name" placeholder="Введіть назву" />
          @if (form.get('name')?.invalid && form.get('name')?.touched) {
          <mat-error>Назва обов'язкова</mat-error>
          }
        </mat-form-field>
      </div>

      <div class="form-row form-row--full">
        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Адреса публічного кар'єрного сайту</mat-label>
          <input matInput formControlName="jobBoardUrl" placeholder="https://..." />
        </mat-form-field>
      </div>

      <div class="form-row form-row--half">
        <mat-form-field appearance="outline" class="form-field">
          <mat-label>План підписки</mat-label>
          <mat-select formControlName="subscription">
            @for (plan of subscriptionOptions; track plan.value) {
            <mat-option [value]="plan.value">{{ plan.label }}</mat-option>
            }
          </mat-select>
          @if (form.get('subscription')?.invalid && form.get('subscription')?.touched) {
          <mat-error>Оберіть план</mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Рівень доступу ШІ</mat-label>
          <mat-select formControlName="aiCvParserAccess">
            @for (level of aiCvParserOptions; track level.value) {
            <mat-option [value]="level.value">{{ level.label }}</mat-option>
            }
          </mat-select>
          @if (form.get('aiCvParserAccess')?.invalid && form.get('aiCvParserAccess')?.touched) {
          <mat-error>Оберіть рівень доступу</mat-error>
          }
        </mat-form-field>
      </div>

      <div class="form-row form-row--end-date">
        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Кінець підписки</mat-label>
          <input matInput [matDatepicker]="picker" [min]="minEndDate" formControlName="endDate" />
          <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      </div>
    </div>

    <div class="form-section">
      <h3 class="section-title">Налаштування порталу</h3>

      <div class="form-row features-toggles">
        <mat-slide-toggle formControlName="allowApplyFromPublicWebsite" color="primary">
          Подача заявок з публічного сайту
        </mat-slide-toggle>
        <mat-slide-toggle formControlName="canAddTeammates" color="primary">
          Додавання учасників команди
        </mat-slide-toggle>
        <mat-slide-toggle formControlName="searchDuplicatesInConsole" color="primary">
          Пошук дублікатів у консолі
        </mat-slide-toggle>
        <mat-slide-toggle formControlName="searchDuplicatesInDetails" color="primary">
          Пошук дублікатів у деталях
        </mat-slide-toggle>
        <mat-slide-toggle formControlName="searchDuplicatesInAts" color="primary">
          Пошук дублікатів в ATS
        </mat-slide-toggle>
      </div>

      <div class="form-row form-row--half">
        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Дні до дедлайну</mat-label>
          <input matInput type="number" formControlName="daysToDeadline" min="1" max="365" />
          @if (form.get('daysToDeadline')?.invalid && form.get('daysToDeadline')?.touched) {
          <mat-error>Введіть число від 1 до 365</mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Кількість рекрутерів</mat-label>
          <input matInput type="number" formControlName="recruiterCount" min="1" max="9999" />
          @if (form.get('recruiterCount')?.invalid && form.get('recruiterCount')?.touched) {
          <mat-error>Введіть число від 1 до 9999</mat-error>
          }
        </mat-form-field>
      </div>
    </div>

    <div class="form-actions">
      <button mat-button type="button" (click)="onCancel()">Скасувати</button>
      <button mat-raised-button color="primary" type="submit" [disabled]="form.invalid" class="submit-btn">
        <mat-icon>check_circle</mat-icon>
        Зберегти
      </button>
    </div>
  </form>
</div>
